import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { PromptTemplate } from '../../../../core';
export var PromptTemplateApiMapper = /*#__PURE__*/function () {
  function PromptTemplateApiMapper() {
    _classCallCheck(this, PromptTemplateApiMapper);
  }

  _createClass(PromptTemplateApiMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      return PromptTemplate.create({
        id: dto.id,
        title: dto.title,
        description: dto.description,
        template: dto.template,
        resourceType: dto.resourceType,
        resourceId: dto.resourceId
      });
    }
  }]);

  return PromptTemplateApiMapper;
}();